import {
  Activity,
  ArchiveRestore,
  BarChart3,
  Bell,
  Bot,
  Building2,
  CalendarClock,
  ClipboardList,
  Clock,
  CreditCard,
  Download,
  FilePlus2,
  FileText,
  Globe2,
  History,
  Home,
  LayoutDashboard,
  Lock,
  MapPin,
  MessageCircle,
  MessageSquare,
  Package,
  PackageCheck,
  PackageOpen,
  PackagePlus,
  Paintbrush,
  Phone,
  ReceiptText,
  RefreshCw,
  RotateCcw,
  Search,
  Send,
  ShieldAlert,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  Settings2,
  Store,
  Ticket,
  Tags,
  Truck,
  Upload,
  UserCheck,
  UserCog,
  Users,
  WalletCards,
} from 'lucide-react';

export const permissionRoles = [
  { key: 'admin', label: 'Admin' },
  { key: 'whitelabel_admin', label: 'White Label Admin' },
  { key: 'employee', label: 'Employee' },
  { key: 'dealer', label: 'Dealer' },
  { key: 'customer', label: 'Customer' }
];

export const moduleCatalog = [
  { key: 'dashboard', title: 'Dashboard', subtitle: 'Role command center', icon: LayoutDashboard, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer', 'customer'], group: 'Core' },
  {
    key: 'users',
    title: 'User Management',
    subtitle: 'All account creation',
    icon: Building2,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
    group: 'Core',
    subItems: [
      {
        key: 'users-accounts',
        title: 'Accounts',
        subtitle: 'User list groups',
        icon: Building2,
        roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
        children: [
          { key: 'users-grouped', title: 'By Admin', subtitle: 'Account-wise user tree', icon: ShieldCheck, roles: ['superadmin', 'admin', 'whitelabel_admin'] },
          { key: 'users-admins', title: 'Admins', subtitle: 'Admin account list', icon: Building2, roles: ['superadmin'] },
          { key: 'users-employees', title: 'Employees', subtitle: 'Employee account list', icon: UserCheck, roles: ['superadmin', 'admin', 'whitelabel_admin'] },
          { key: 'users-dealers', title: 'Dealers', subtitle: 'Dealer account list', icon: Store, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'] },
          { key: 'users-customers', title: 'Customers', subtitle: 'Customer account list', icon: UserCog, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'] }
        ]
      },
      {
        key: 'users-office-location',
        title: 'Office Location',
        subtitle: 'Employee office mapping',
        icon: ClipboardList,
        roles: ['superadmin', 'admin', 'whitelabel_admin'],
        children: [
          { key: 'users-office-location-map', title: 'Office Location Map', subtitle: 'Employee location mapping', icon: ClipboardList },
          { key: 'users-create-office-location', title: 'Create Office Location', subtitle: 'Add office location', icon: PackagePlus }
        ]
      },
      {
        key: 'users-entry',
        title: 'Entry',
        subtitle: 'Create accounts',
        icon: FilePlus2,
        roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
        children: [
          { key: 'users-create-user', title: 'Create User', subtitle: 'Add account user', icon: FilePlus2 }
        ]
      },
      {
        key: 'users-master',
        title: 'Master Search',
        subtitle: 'Find any account',
        icon: Search,
        roles: ['superadmin'],
        children: [
          { key: 'users-master-search', title: 'Master Search', subtitle: 'Users, vendors, customers', icon: Search, roles: ['superadmin'] }
        ]
      },
      {
        key: 'users-reports',
        title: 'Reports',
        subtitle: 'User reports',
        icon: FileText,
        roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
        children: [
          { key: 'users-report-summary', title: 'User Summary', subtitle: 'Summary counters', icon: BarChart3 },
          { key: 'users-report-all', title: 'All Users Report', subtitle: 'Full user list', icon: FileText },
          { key: 'users-report-admin', title: 'Admin Report', subtitle: 'Admin accounts', icon: Building2, roles: ['superadmin'] },
          { key: 'users-report-whitelabel', title: 'White Label Report', subtitle: 'White label accounts', icon: Home, roles: ['superadmin'] },
          { key: 'users-report-employee', title: 'Employee Report', subtitle: 'Employee accounts', icon: UserCheck, roles: ['superadmin', 'admin', 'whitelabel_admin'] },
          { key: 'users-report-dealer', title: 'Dealer Report', subtitle: 'Dealer accounts', icon: Store },
          { key: 'users-report-customer', title: 'Customer Report', subtitle: 'Customer accounts', icon: UserCog },
          { key: 'users-report-active', title: 'Active Users Report', subtitle: 'Active accounts', icon: ShieldCheck },
          { key: 'users-report-inactive', title: 'Inactive Users Report', subtitle: 'Inactive accounts', icon: ArchiveRestore },
          { key: 'users-report-by-admin', title: 'Admin Wise Report', subtitle: 'Admin-wise team', icon: ClipboardList, roles: ['superadmin', 'admin', 'whitelabel_admin'] }
        ]
      }
    ]
  },
  {
    key: 'notifications',
    title: 'Notification',
    subtitle: 'Send app alerts',
    icon: Bell,
    roles: ['admin', 'whitelabel_admin'],
    strictRoles: ['admin', 'whitelabel_admin'],
    group: 'Core',
    subItems: [
      {
        key: 'notifications-send-to',
        title: 'Send To',
        subtitle: 'Recipient mode',
        icon: Send,
        children: [
          { key: 'notification-single', title: 'Single User', subtitle: 'One user/customer', icon: UserCheck },
          { key: 'notification-category', title: 'User Category', subtitle: 'Role/category broadcast', icon: Store }
        ]
      },
      {
        key: 'notifications-templates',
        title: 'Templates',
        subtitle: 'Message templates',
        icon: FileText,
        children: [
          { key: 'notification-template-renewal', title: 'Renewal Reminder', subtitle: 'Renewal template', icon: RefreshCw },
          { key: 'notification-template-info', title: 'Information', subtitle: 'Info template', icon: Bell }
        ]
      },
      {
        key: 'notifications-voice',
        title: 'Voice',
        subtitle: 'Voice message',
        icon: MessageCircle,
        children: [
          { key: 'notification-voice-enabled', title: 'Voice Enabled', subtitle: 'Enable voice alert', icon: Bell },
          { key: 'notification-voice-disabled', title: 'Voice Disabled', subtitle: 'Disable voice alert', icon: Bell }
        ]
      }
    ]
  },
  {
    key: 'purchase',
    title: 'Purchase',
    subtitle: 'Vendor and inward stock',
    icon: ShoppingBag,
    roles: ['superadmin', 'admin', 'whitelabel_admin'],
    group: 'Core',
    subItems: [
      { key: 'purchase-vendor', title: 'Vendor', subtitle: 'Vendor details', icon: Building2, children: [
        { key: 'purchase-create-vendor', title: 'Create Vendor', subtitle: 'Add vendor', icon: Building2 },
        { key: 'purchase-vendor-ledger', title: 'Vendor Debit Credit', subtitle: 'Vendor balance', icon: WalletCards }
      ] },
      { key: 'purchase-entry', title: 'Purchase & Inward', subtitle: 'Stock inward entries', icon: ShoppingBag, children: [
        { key: 'purchase-entry-form', title: 'Purchase Entry', subtitle: 'Create purchase & inward', icon: ShoppingBag },
        { key: 'purchase-bulk-upload', title: 'Bulk Stock Inward', subtitle: 'Excel stock inward', icon: Upload },
        { key: 'purchase-inward-devices', title: 'Inward Devices', subtitle: 'Device rows', icon: Package },
        { key: 'purchase-ledger', title: 'Purchase Ledger', subtitle: 'Purchase invoice ledger', icon: ClipboardList }
      ] }
    ]
  },
  {
    key: 'inventory',
    title: 'Inventory',
    subtitle: 'Stock management',
    icon: Package,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
    group: 'Core',
    subItems: [
      {
        key: 'live-inventory-report',
        title: 'Live Inventory Report',
        subtitle: 'Stock and device report',
        icon: BarChart3,
        children: [
          { key: 'live-stock-list', title: 'Stock List', subtitle: 'All IMEI, SIM and device stock', icon: Package },
          { key: 'live-purchase-inventory', title: 'Purchase Inventory', subtitle: 'Vendor purchase entries', icon: FileText, roles: ['superadmin', 'admin', 'whitelabel_admin'] },
          { key: 'live-inventory-return-report', title: 'Inventory Return', subtitle: 'Returned device details', icon: RotateCcw, roles: ['superadmin', 'admin', 'whitelabel_admin'] },
          {
            key: 'live-stock-status',
            title: 'Stock Status',
            subtitle: 'Status filters',
            icon: PackageCheck,
            children: [
              { key: 'live-available-stock', title: 'Available Stock', subtitle: 'Ready device stock', icon: PackageCheck },
              { key: 'live-sold-devices', title: 'Sold Devices', subtitle: 'Devices mapped with sales', icon: ShoppingCart },
              { key: 'live-defective-stock', title: 'Defective Stock', subtitle: 'Repair and replacement stock', icon: ShieldCheck },
              { key: 'live-low-stock-alert', title: 'Low Stock Alert', subtitle: 'Below minimum stock', icon: ShieldCheck, roles: ['superadmin', 'admin', 'whitelabel_admin'] }
            ]
          },
          {
            key: 'live-office-location',
            title: 'Office Location',
            subtitle: 'Office location stock',
            icon: Building2,
            children: [
              { key: 'live-office-location-stock', title: 'Office Location Stock', subtitle: 'Location-wise stock tally', icon: Building2 },
              { key: 'live-assign-employee', title: 'Assign Employee', subtitle: 'Map employee access', icon: ClipboardList, roles: ['superadmin', 'admin', 'whitelabel_admin'] }
            ]
          },
          {
            key: 'live-transfer',
            title: 'Transfer',
            subtitle: 'Movement options',
            icon: Truck,
            children: [
              { key: 'live-stock-transfer', title: 'Stock Transfer', subtitle: 'Move stock location', icon: Truck, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'] },
              { key: 'live-transfer-history', title: 'Transfer History', subtitle: 'Stock movement ledger', icon: History, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'] }
            ]
          },
          {
            key: 'live-masters',
            title: 'Masters',
            subtitle: 'Inventory masters',
            icon: Settings2,
            roles: ['superadmin', 'admin', 'whitelabel_admin'],
            children: [
              { key: 'live-product-type', title: 'Product Type', subtitle: 'Create product type', icon: Tags },
              { key: 'live-oem-name', title: 'OEM Name', subtitle: 'Create OEM names', icon: ClipboardList },
              { key: 'live-device-name', title: 'Device Name', subtitle: 'Create device names', icon: Settings2 },
              { key: 'live-product-master', title: 'Product Master', subtitle: 'Create inventory products', icon: PackageOpen }
            ]
          },
          {
            key: 'live-entry',
            title: 'Entry',
            subtitle: 'Inventory entries',
            icon: PackagePlus,
            roles: ['superadmin', 'admin', 'whitelabel_admin'],
            children: [
              { key: 'live-add-stock', title: 'Add Stock', subtitle: 'IMEI, SIM and device stock', icon: PackagePlus },
              { key: 'live-bulk-upload', title: 'Bulk Upload', subtitle: 'Inventory sample upload', icon: Upload },
              { key: 'live-return-entry', title: 'Return Entry', subtitle: 'Returned stock entry', icon: RotateCcw }
            ]
          }
        ]
      },
      {
        key: 'inventory-module',
        title: 'Inventory Module',
        subtitle: 'Master and entry options',
        icon: Package,
        roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
        children: [
          {
            key: 'inventory-reports',
            title: 'Reports',
            subtitle: 'Download reports',
            icon: Download,
            roles: ['superadmin', 'admin', 'whitelabel_admin'],
            children: [
              { key: 'inventory-download-report', title: 'Download Report', subtitle: 'Current stock report', icon: Download },
              { key: 'inventory-return-report', title: 'Return Report', subtitle: 'Inventory return report', icon: Download }
            ]
          },
          {
            key: 'inventory-stock',
            title: 'Stock',
            subtitle: 'Stock filters',
            icon: Package,
            roles: ['superadmin', 'admin', 'whitelabel_admin'],
            children: [
              { key: 'inventory-stock-total', title: 'Total Stock', subtitle: 'All stock entries', icon: Package },
              { key: 'inventory-stock-available', title: 'Available Stock', subtitle: 'Ready stock list', icon: PackageCheck },
              { key: 'inventory-stock-sold', title: 'Sold Stock', subtitle: 'Sold device list', icon: ShoppingCart },
              { key: 'inventory-stock-defective', title: 'Defective Stock', subtitle: 'Repair stock list', icon: ShieldCheck }
            ]
          },
          {
            key: 'inventory-transfer',
            title: 'Transfer',
            subtitle: 'Stock movement',
            icon: Truck,
            children: [
              { key: 'inventory-transfer-stock', title: 'Stock Transfer', subtitle: 'Move stock location', icon: Truck, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'] },
              { key: 'inventory-transfer-history', title: 'Transfer History', subtitle: 'Stock movement ledger', icon: History, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'] }
            ]
          },
          {
            key: 'inventory-masters',
            title: 'Masters',
            subtitle: 'Product masters',
            icon: Settings2,
            roles: ['superadmin', 'admin', 'whitelabel_admin'],
            children: [
              { key: 'inventory-product-type', title: 'Product Type', subtitle: 'Create product type', icon: Tags },
              { key: 'inventory-oem-name', title: 'OEM Name', subtitle: 'Create OEM names', icon: ClipboardList },
              { key: 'inventory-device-name', title: 'Device Name', subtitle: 'Create device names', icon: Settings2 },
              { key: 'inventory-new-product', title: 'New Product', subtitle: 'Product master', icon: PackageOpen }
            ]
          },
          {
            key: 'inventory-entry',
            title: 'Entry',
            subtitle: 'Stock entry actions',
            icon: PackagePlus,
            roles: ['superadmin', 'admin', 'whitelabel_admin'],
            children: [
              { key: 'inventory-add-stock', title: 'Add Stock', subtitle: 'IMEI, SIM and device stock', icon: PackagePlus },
              { key: 'inventory-bulk-upload', title: 'Bulk Upload', subtitle: 'Inventory sample upload', icon: Upload },
              { key: 'inventory-return-entry', title: 'Inventory Return', subtitle: 'Returned stock entry', icon: RotateCcw }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'sales',
    title: 'Sales',
    subtitle: 'Pipeline and billing',
    icon: ShoppingCart,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'],
    group: 'Core',
    subItems: [
      {
        key: 'sales-device',
        title: 'Device Sales',
        subtitle: 'Device and inventory billing',
        icon: ShoppingCart,
        children: [
          { key: 'sales-new-customer', title: 'New Customer', subtitle: 'New customer sale', icon: UserCheck },
          { key: 'sales-existing-customer', title: 'Existing Customer', subtitle: 'Existing customer sale', icon: Users }
        ]
      },
      {
        key: 'sales-service',
        title: 'Service Sales',
        subtitle: 'Only service billing',
        icon: ReceiptText,
        children: [
          { key: 'service-sale', title: 'New Service Sales', subtitle: 'New service billing', icon: ReceiptText },
          { key: 'sales-service-existing', title: 'Existing Customer Sales', subtitle: 'Service for existing customer', icon: UserCheck }
        ]
      }
    ]
  },
  {
    key: 'gps-tracking',
    title: 'GPS Tracking',
    subtitle: 'Customer vehicle tracking',
    icon: MapPin,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
    group: 'Core',
    subItems: [
      { key: 'gps-live', title: 'Live Tracking', subtitle: 'Map views', icon: MapPin, children: [
        { key: 'gps-live-map', title: 'Live Map', subtitle: 'Current location', icon: MapPin },
        { key: 'gps-playback', title: 'Playback', subtitle: 'Route playback', icon: RefreshCw },
        { key: 'gps-history', title: 'History', subtitle: 'History panel', icon: History }
      ] },
      { key: 'gps-commands', title: 'Commands', subtitle: 'Device commands', icon: Settings2, children: [
        { key: 'gps-command-lock', title: 'Lock / Unlock', subtitle: 'Immobilizer command', icon: ShieldCheck },
        { key: 'gps-command-location', title: 'Current Location', subtitle: 'Fetch location', icon: MapPin },
        { key: 'gps-command-reboot', title: 'Reboot Device', subtitle: 'Device reboot', icon: RefreshCw },
        { key: 'gps-command-apn', title: 'Change APN', subtitle: 'APN command', icon: Settings2 },
        { key: 'gps-command-geofence', title: 'Geo-fence', subtitle: 'Geo-fence command', icon: MapPin },
        { key: 'gps-command-sos', title: 'SOS', subtitle: 'SOS command', icon: Bell }
      ] },
      { key: 'gps-reports', title: 'Reports', subtitle: 'GPS reports', icon: FileText, children: [
        { key: 'gps-report-trip', title: 'Trip Report', subtitle: 'Trip data', icon: FileText },
        { key: 'gps-report-km', title: 'KM Report', subtitle: 'Distance data', icon: FileText },
        { key: 'gps-report-stop-idle', title: 'Stop / Idle / Parking', subtitle: 'Stop reports', icon: History },
        { key: 'gps-report-overspeed', title: 'Overspeed', subtitle: 'Overspeed report', icon: ShieldCheck },
        { key: 'gps-report-daily-summary', title: 'Daily Summary', subtitle: 'Daily GPS summary', icon: BarChart3 },
        { key: 'gps-report-offline', title: 'Device Offline', subtitle: 'Offline report', icon: ArchiveRestore }
      ] },
      { key: 'gps-alerts', title: 'Alerts', subtitle: 'GPS alerts', icon: Bell, children: [
        { key: 'gps-alert-overspeed', title: 'Overspeed', subtitle: 'Overspeed alert', icon: Bell },
        { key: 'gps-alert-ignition', title: 'Ignition', subtitle: 'Ignition alert', icon: Bell },
        { key: 'gps-alert-power', title: 'Power Cut', subtitle: 'Power alert', icon: Bell },
        { key: 'gps-alert-low-battery', title: 'Low Battery', subtitle: 'Battery alert', icon: Bell },
        { key: 'gps-alert-geofence', title: 'Geo-fence', subtitle: 'Geo-fence alert', icon: MapPin },
        { key: 'gps-alert-sos', title: 'SOS', subtitle: 'SOS alert', icon: Bell }
      ] },
      { key: 'gps-super-admin', title: 'Super Admin', subtitle: 'GPS diagnostics', icon: ShieldCheck, roles: ['superadmin'], strictRoles: ['superadmin'], children: [
        { key: 'gps-protocol-monitor', title: 'Protocol Monitor', subtitle: 'IMEI protocol auto fetch', icon: Activity, roles: ['superadmin'], strictRoles: ['superadmin'] }
      ] }
    ]
  },
  {
    key: 'reminders',
    title: 'Reminder',
    subtitle: 'Renewal notification rules',
    icon: CalendarClock,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
    group: 'Core',
    subItems: [
      { key: 'reminder-categories', title: 'Reminder Rules', subtitle: 'Category setup', icon: CalendarClock, children: [
        { key: 'reminder-gps-renewal', title: 'GPS Service Renewal', subtitle: 'GPS reminder', icon: RefreshCw },
        { key: 'reminder-insurance', title: 'Insurance Renewal', subtitle: 'Insurance reminder', icon: ShieldCheck },
        { key: 'reminder-amc', title: 'AMC Renewal', subtitle: 'AMC reminder', icon: CalendarClock }
      ] },
      { key: 'reminder-send', title: 'Send Reminder', subtitle: 'Reminder broadcast', icon: Send, children: [
        { key: 'reminder-single', title: 'Single Recipient', subtitle: 'One recipient', icon: UserCheck },
        { key: 'reminder-category', title: 'Recipient Category', subtitle: 'Category send', icon: Store }
      ] }
    ]
  },
  {
    key: 'vehicle-services',
    title: 'Vehicle Services',
    subtitle: 'Expiry and service ledger',
    icon: ShieldCheck,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'],
    group: 'Core',
    subItems: [
      { key: 'vehicle-service-status', title: 'Service Status', subtitle: 'Status filters', icon: ShieldCheck, children: [
        { key: 'vehicle-service-upcoming', title: 'Upcoming', subtitle: 'Upcoming services', icon: CalendarClock },
        { key: 'vehicle-service-followup', title: 'Follow-up Pending', subtitle: 'Follow-up services', icon: Bell },
        { key: 'vehicle-service-quoted', title: 'Quoted', subtitle: 'Quoted services', icon: FileText },
        { key: 'vehicle-service-converted', title: 'Converted', subtitle: 'Converted services', icon: PackageCheck },
        { key: 'vehicle-service-active', title: 'Active', subtitle: 'Active services', icon: ShieldCheck },
        { key: 'vehicle-service-expired', title: 'Expired', subtitle: 'Expired services', icon: ArchiveRestore },
        { key: 'vehicle-service-lost', title: 'Lost', subtitle: 'Lost services', icon: ArchiveRestore }
      ] },
      { key: 'vehicle-service-type', title: 'Service Type', subtitle: 'Common services', icon: Settings2, children: [
        { key: 'vehicle-service-gps-renewal', title: 'GPS Renewal', subtitle: 'GPS renewal', icon: RefreshCw },
        { key: 'vehicle-service-insurance', title: 'Insurance', subtitle: 'Insurance service', icon: ShieldCheck },
        { key: 'vehicle-service-fitness', title: 'Fitness', subtitle: 'Fitness certificate', icon: ClipboardList },
        { key: 'vehicle-service-puc', title: 'PUC', subtitle: 'Pollution certificate', icon: FileText },
        { key: 'vehicle-service-permit', title: 'Permit', subtitle: 'Permit service', icon: FileText },
        { key: 'vehicle-service-fastag', title: 'FASTag', subtitle: 'FASTag service', icon: CreditCard },
        { key: 'vehicle-service-other', title: 'Other Service', subtitle: 'Custom service', icon: Settings2 }
      ] }
    ]
  },
  {
    key: 'accounts',
    title: 'Account Section',
    subtitle: 'Ledger and dues',
    icon: WalletCards,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'],
    group: 'Core',
    subItems: [
      { key: 'accounts-summary', title: 'Summary', subtitle: 'Revenue snapshot', icon: BarChart3, children: [
        { key: 'accounts-revenue', title: 'Revenue', subtitle: 'Revenue metrics', icon: WalletCards },
        { key: 'accounts-dues', title: 'Pending Dues', subtitle: 'Pending balance', icon: CreditCard }
      ] },
      { key: 'accounts-ledger', title: 'Ledger', subtitle: 'Ledger tables', icon: ClipboardList, children: [
        { key: 'accounts-credit-debit-ledger', title: 'Credit Debit Ledger', subtitle: 'Ledger preview', icon: ClipboardList },
        { key: 'accounts-payment-flow', title: 'Daily Payment Flow', subtitle: 'Payment flow', icon: CreditCard }
      ] }
    ]
  },
  {
    key: 'reports',
    title: 'Reports',
    subtitle: 'Exports and analytics',
    icon: FileText,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'],
    group: 'Core',
    subItems: [
      { key: 'reports-sales', title: 'Sales', subtitle: 'Sales reports', icon: ShoppingCart, children: [
        { key: 'sales-daily', title: 'Daily Sales Report', subtitle: "Today's sales", icon: FileText },
        { key: 'sales-monthly', title: 'Monthly Sales Report', subtitle: 'Monthly sales', icon: FileText },
        { key: 'device-sales', title: 'Device Sales Report', subtitle: 'Device sales', icon: ShoppingCart },
        { key: 'service-sales', title: 'Service Sales Report', subtitle: 'Service sales', icon: ReceiptText },
        { key: 'sales-all', title: 'All Combined Sales Report', subtitle: 'Device and Service sales', icon: ShoppingCart },
        { key: 'employee-wise-sales', title: 'Employee Wise Sales Report', subtitle: 'Employee sales', icon: Users },
        { key: 'office-wise-sales', title: 'Office Wise Sales Report', subtitle: 'Office sales', icon: Building2 }
      ] },
      { key: 'reports-customers', title: 'Customers', subtitle: 'Customer report', icon: UserCog, children: [
        { key: 'customers', title: 'Customers Report', subtitle: 'Customer list', icon: UserCog }
      ] },
      { key: 'reports-inventory', title: 'Inventory', subtitle: 'Inventory reports', icon: Package, roles: ['superadmin', 'admin', 'whitelabel_admin'], children: [
        { key: 'inventory', title: 'Inventory Report', subtitle: 'Stock report', icon: Package }
      ] },
      { key: 'reports-finance', title: 'Finance', subtitle: 'Payment reports', icon: WalletCards, children: [
        { key: 'payments', title: 'All Payment Report', subtitle: 'Payment history', icon: CreditCard },
        { key: 'payments-debit-credit', title: 'Debit Credit Payment Report', subtitle: 'Combined credits & debits', icon: CreditCard },
        { key: 'payment-report-customer', title: 'Customer Payment Report', subtitle: 'Customer payments', icon: UserCog },
        { key: 'payment-report-dealer', title: 'Dealer Payment Report', subtitle: 'Dealer payments', icon: Store },
        { key: 'payment-report-purchase', title: 'Purchase Payment Report', subtitle: 'Purchase payments', icon: ShoppingBag, roles: ['superadmin', 'admin', 'whitelabel_admin'] },
        { key: 'credit-debit-ledger', title: 'All Credit/Debit Ledger', subtitle: 'All ledger', icon: WalletCards },
        { key: 'ledger-report-admin', title: 'Admin Credit/Debit Ledger', subtitle: 'Admin ledger', icon: Building2 },
        { key: 'ledger-report-employee', title: 'Employee Credit/Debit Ledger', subtitle: 'Employee ledger', icon: UserCheck },
        { key: 'ledger-report-dealer', title: 'Dealer Credit/Debit Ledger Details', subtitle: 'Dealer ledger details', icon: Store },
        { key: 'pending-payments', title: 'Pending Payments', subtitle: 'Pending payment list', icon: CreditCard },
        { key: 'dealer-wise', title: 'Dealer Wise Report', subtitle: 'Dealer ledger report', icon: Store }
      ] },
      { key: 'reports-renewal', title: 'Renewal', subtitle: 'Renewal reports', icon: RefreshCw, children: [
        { key: 'renewals', title: 'Renewals Report', subtitle: 'Renewal list', icon: RefreshCw }
      ] },
      { key: 'reports-activity', title: 'Activity', subtitle: 'Activity reports', icon: ClipboardList, roles: ['superadmin', 'admin', 'whitelabel_admin'], children: [
        { key: 'activity-history', title: 'Activity History Report', subtitle: 'Workspace logs', icon: ClipboardList }
      ] }
    ]
  },
  { key: 'activity-history', title: 'Activity History', subtitle: 'Workspace action logs', icon: ClipboardList, roles: ['superadmin', 'admin', 'whitelabel_admin'], group: 'Core', subItems: [
    { key: 'activity-logs', title: 'Logs', subtitle: 'Workspace logs', icon: ClipboardList, children: [
      { key: 'activity-workspace-logs', title: 'Workspace Logs', subtitle: 'Latest logs', icon: ClipboardList },
      { key: 'activity-download', title: 'Download', subtitle: 'Download activity', icon: Download }
    ] }
  ] },
  { key: 'correction-requests', title: 'Correction Requests', subtitle: 'Approval based edits', icon: ClipboardList, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'], group: 'Core', subItems: [
    { key: 'correction-request-list', title: 'Requests', subtitle: 'Pending and decided', icon: ClipboardList }
  ] },
  {
    key: 'whatsapp',
    title: 'WhatsApp Work Panel',
    subtitle: 'Internal message queue',
    icon: MessageCircle,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'],
    group: 'Workspace',
    subItems: [
      { key: 'whatsapp-config', title: 'Config', subtitle: 'Number and message', icon: Settings2, children: [
        { key: 'whatsapp-number-config', title: 'WhatsApp Number', subtitle: 'Saved number', icon: Phone },
        { key: 'whatsapp-template', title: 'Default Message', subtitle: 'Message template', icon: MessageCircle },
        { key: 'whatsapp-quick-entry', title: 'Quick Entry', subtitle: 'Quick work entry', icon: Send }
      ] },
      { key: 'whatsapp-work-queue', title: 'Work Queue', subtitle: 'Queue filters', icon: ClipboardList, children: [
        { key: 'whatsapp-work-all', title: 'All', subtitle: 'All work items', icon: ClipboardList },
        { key: 'whatsapp-work-draft', title: 'Draft', subtitle: 'Draft items', icon: FileText },
        { key: 'whatsapp-work-ready', title: 'Ready', subtitle: 'Ready items', icon: PackageCheck },
        { key: 'whatsapp-work-sent', title: 'Sent', subtitle: 'Sent items', icon: Send },
        { key: 'whatsapp-work-cancelled', title: 'Cancelled', subtitle: 'Cancelled items', icon: ArchiveRestore }
      ] }
    ]
  },
  { key: 'team-chat', title: 'Team Chat', subtitle: 'Admin allowed requests', icon: MessageSquare, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'], group: 'Workspace', subItems: [
    { key: 'team-chat-panel', title: 'Chat Panel', subtitle: 'Team messages', icon: MessageSquare, children: [
      { key: 'team-chat-accepted', title: 'Accepted Chats', subtitle: 'Active chats', icon: MessageSquare },
      { key: 'team-chat-refresh', title: 'Refresh', subtitle: 'Reload chat', icon: RefreshCw }
    ] }
  ] },
  {
    key: 'payments',
    title: 'Payments',
    subtitle: 'Ledger and dues',
    icon: CreditCard,
    roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'],
    group: 'Workspace',
    subItems: [
      { key: 'payments-entry', title: 'Entry', subtitle: 'Record payment', icon: CreditCard, children: [
        { key: 'payments-record', title: 'Record Payment', subtitle: 'New payment', icon: CreditCard },
        { key: 'payments-record-customer', title: 'Customer Payment', subtitle: 'Customer payment', icon: UserCog },
        { key: 'payments-record-dealer', title: 'Dealer Payment', subtitle: 'Dealer payment', icon: Store },
        { key: 'payments-record-vendor', title: 'Vendor Payment', subtitle: 'Vendor payment', icon: ShoppingBag, roles: ['superadmin', 'admin', 'whitelabel_admin'] }
      ] },
      { key: 'payments-history', title: 'Payment History', subtitle: 'Payment filters', icon: History, children: [
        { key: 'payments-history-all', title: 'All Payments', subtitle: 'All payments', icon: History },
        { key: 'payments-history-customer', title: 'Customer', subtitle: 'Customer payments', icon: UserCog },
        { key: 'payments-history-dealer', title: 'Dealer', subtitle: 'Dealer payments', icon: Store },
        { key: 'payments-history-vendor', title: 'Vendor', subtitle: 'Vendor payments', icon: ShoppingBag, roles: ['superadmin', 'admin', 'whitelabel_admin'] }
      ] },
      { key: 'payments-ledger', title: 'Credit/Debit Ledger', subtitle: 'Ledger filters', icon: WalletCards, children: [
        { key: 'payments-ledger-all', title: 'All Ledger', subtitle: 'All ledger', icon: WalletCards },
        { key: 'payments-ledger-admin', title: 'Admin Ledger', subtitle: 'Admin ledger', icon: Building2 },
        { key: 'payments-ledger-employee', title: 'Employee Ledger', subtitle: 'Employee ledger', icon: UserCheck },
        { key: 'payments-ledger-dealer', title: 'Dealer Ledger', subtitle: 'Dealer ledger', icon: Store },
        { key: 'payments-ledger-vendor', title: 'Vendor Ledger', subtitle: 'Vendor ledger', icon: ShoppingBag, roles: ['superadmin', 'admin', 'whitelabel_admin'] }
      ] }
    ]
  },
  { key: 'renewals', title: 'Renewals', subtitle: 'Expiry reminders', icon: RefreshCw, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee'], group: 'Workspace', subItems: [
    { key: 'renewals-status', title: 'Status', subtitle: 'Renewal filters', icon: RefreshCw, children: [
      { key: 'renewals-all', title: 'All', subtitle: 'All renewals', icon: FileText },
      { key: 'renewals-overdue', title: 'Overdue', subtitle: 'Overdue renewals', icon: ArchiveRestore },
      { key: 'renewals-today', title: 'Today', subtitle: 'Expiring today', icon: CalendarClock },
      { key: 'renewals-7days', title: '7 Days', subtitle: 'Within 7 days', icon: CalendarClock },
      { key: 'renewals-30days', title: '30 Days', subtitle: 'Within 30 days', icon: CalendarClock }
    ] }
  ] },
  {
    key: 'white-label',
    title: 'White Label Management',
    subtitle: 'Accounts and app generation',
    icon: Paintbrush,
    roles: ['superadmin'],
    group: 'AI SaaS',
    subItems: [
      { key: 'white-label-builder', title: 'Builder', subtitle: 'Brand builder', icon: Paintbrush, children: [
        { key: 'white-label-upload-logo', title: 'Upload Logo', subtitle: 'Brand logo', icon: Upload },
        { key: 'white-label-theme-color', title: 'Change Theme Color', subtitle: 'Theme color', icon: Paintbrush },
        { key: 'white-label-brand-reports', title: 'Brand Reports', subtitle: 'Brand report settings', icon: FileText }
      ] },
      { key: 'white-label-domain', title: 'Domain & SSL', subtitle: 'Domain setup', icon: Globe2, children: [
        { key: 'white-label-save-domain', title: 'Save Domain', subtitle: 'Custom domain', icon: Globe2 },
        { key: 'white-label-check-dns', title: 'Check DNS', subtitle: 'DNS check', icon: Globe2 },
        { key: 'white-label-generate-nginx', title: 'Generate Nginx', subtitle: 'Nginx config', icon: Package },
        { key: 'white-label-issue-ssl', title: 'Issue SSL', subtitle: 'SSL certificate', icon: Lock },
        { key: 'white-label-verify-domain', title: 'Verify Domain', subtitle: 'Domain live check', icon: RefreshCw }
      ] },
      { key: 'white-label-apps', title: 'App Generation', subtitle: 'Mobile apps', icon: Smartphone, children: [
        { key: 'white-label-android', title: 'Android', subtitle: 'Android APK', icon: Smartphone },
        { key: 'white-label-ios', title: 'iOS', subtitle: 'iOS package', icon: Smartphone },
        { key: 'white-label-app-downloads', title: 'Download / Publish Update', subtitle: 'App updates', icon: Download }
      ] },
      { key: 'white-label-accounts', title: 'Accounts', subtitle: 'Workspace accounts', icon: Building2, children: [
        { key: 'white-label-create-account', title: 'Create White Label Account', subtitle: 'Create account', icon: Building2 },
        { key: 'white-label-workspace-accounts', title: 'White Label Accounts', subtitle: 'White label admin list', icon: Home }
      ] }
    ]
  },
  { key: 'user-chatbot', title: 'User Chatbot', subtitle: 'Ask BizTrack AI', icon: Bot, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'], group: 'AI SaaS', subItems: [
    { key: 'user-chatbot-panel', title: 'AI Chat', subtitle: 'Ask AI', icon: Bot, children: [
      { key: 'user-chatbot-ask', title: 'Ask BizTrack AI', subtitle: 'CRM insight chat', icon: Bot }
    ] }
  ] },
  { key: 'support', title: 'Ticket Support', subtitle: 'Customer help desk', icon: Ticket, roles: ['superadmin', 'admin', 'whitelabel_admin', 'employee', 'dealer'], group: 'AI SaaS', subItems: [
    { key: 'support-ticket', title: 'Ticket', subtitle: 'Ticket actions', icon: Ticket, children: [
      { key: 'support-create-ticket', title: 'Create Ticket', subtitle: 'New support ticket', icon: Ticket },
      { key: 'support-download-ticket', title: 'Download Tickets', subtitle: 'Export tickets', icon: Download }
    ] },
    { key: 'support-ticket-filters', title: 'Ticket Filters', subtitle: 'Ticket status', icon: ClipboardList, children: [
      { key: 'support-ticket-all', title: 'All', subtitle: 'All tickets', icon: FileText },
      { key: 'support-ticket-open', title: 'Open', subtitle: 'Open tickets', icon: Bell },
      { key: 'support-ticket-progress', title: 'Progress', subtitle: 'In progress tickets', icon: RefreshCw },
      { key: 'support-ticket-resolved', title: 'Resolved', subtitle: 'Resolved tickets', icon: PackageCheck }
    ] }
  ] },
  { key: 'delete-history', title: 'Delete History', subtitle: 'Restore deleted records', icon: ArchiveRestore, roles: ['superadmin'], strictRoles: ['superadmin'], group: 'Admin Tools', subItems: [
    { key: 'delete-history-status', title: 'Status', subtitle: 'Restore filters', icon: ArchiveRestore, children: [
      { key: 'delete-history-deleted', title: 'Deleted', subtitle: 'Deleted records', icon: ArchiveRestore },
      { key: 'delete-history-restored', title: 'Restored', subtitle: 'Restored records', icon: RotateCcw },
      { key: 'delete-history-all', title: 'All', subtitle: 'All records', icon: FileText }
    ] }
  ] },
  { key: 'menu-permissions', title: 'Menu Permissions', subtitle: 'Role menu visibility', icon: ShieldCheck, roles: ['superadmin'], strictRoles: ['superadmin'], group: 'Admin Tools', subItems: [
    { key: 'menu-permission-sections', title: 'Permission Sections', subtitle: 'Show/hide controls', icon: ShieldCheck, children: [
      { key: 'menu-permission-menu', title: 'Main Menu', subtitle: 'Menu visibility', icon: LayoutDashboard },
      { key: 'menu-permission-submenu', title: 'Sub Menu', subtitle: 'Sub options', icon: ClipboardList },
      { key: 'menu-permission-report', title: 'Report Options', subtitle: 'Report visibility', icon: FileText }
    ] }
  ] },
  { key: 'system-master-logs', title: 'System Master Logs', subtitle: 'All application audit & logs', icon: ShieldAlert, roles: ['superadmin'], strictRoles: ['superadmin'], group: 'Admin Tools', subItems: [
    { key: 'master-logs-all', title: 'All Master Logs', subtitle: 'Central Forensic Hub', icon: ShieldAlert, children: [
      { key: 'master-logs-activity', title: 'Activity & Actions', subtitle: 'User events', icon: ClipboardList },
      { key: 'master-logs-driver', title: 'Driver Assignments', subtitle: 'Vehicle driver logs', icon: Clock },
      { key: 'master-logs-delete', title: 'Deleted Archive', subtitle: 'Deleted snapshots', icon: ArchiveRestore },
      { key: 'master-logs-errors', title: 'Server Error Logs', subtitle: 'Server & HTTP errors', icon: ShieldAlert }
    ] }
  ] }
];

export const reportPermissionItems = [
  { key: 'sales-daily', title: 'Daily Sales Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'sales-monthly', title: 'Monthly Sales Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'device-sales', title: 'Device Sales Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'service-sales', title: 'Service Sales Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'sales-all', title: 'All Combined Sales Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'employee-wise-sales', title: 'Employee Wise Sales Report', roles: ['admin', 'whitelabel_admin', 'employee'] },
  { key: 'office-wise-sales', title: 'Office Wise Sales Report', roles: ['admin', 'whitelabel_admin', 'employee'] },
  { key: 'customers', title: 'Customers Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'inventory', title: 'Inventory Report', roles: ['admin', 'whitelabel_admin'] },
  { key: 'payments', title: 'Payments Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'payments-debit-credit', title: 'Debit Credit Payment Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'payment-report-customer', title: 'Customer Payment Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'payment-report-dealer', title: 'Dealer Payment Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'payment-report-purchase', title: 'Purchase Payment Report', roles: ['admin', 'whitelabel_admin'] },
  { key: 'credit-debit-ledger', title: 'All Credit/Debit Ledger', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'ledger-report-admin', title: 'Admin Credit/Debit Ledger', roles: ['admin', 'whitelabel_admin'] },
  { key: 'ledger-report-employee', title: 'Employee Credit/Debit Ledger', roles: ['admin', 'whitelabel_admin', 'employee'] },
  { key: 'ledger-report-dealer', title: 'Dealer Credit/Debit Ledger Details', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'renewals', title: 'Renewals Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'pending-payments', title: 'Pending Payments', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'dealer-wise', title: 'Dealer Wise Report', roles: ['admin', 'whitelabel_admin', 'employee', 'dealer'] },
  { key: 'activity-history', title: 'Activity History Report', roles: ['admin', 'whitelabel_admin'] }
];
